import React from 'react';
import TracksSection from '../components/TracksSection';

const Tracks: React.FC = () => {
  return (
    <div className="tracks-page">
      <TracksSection />
    </div>
  );
};

export default Tracks;
